// Phase APP-2 · Sidebar badge — pending approvals count.
// Polls /api/approvals/metrics every 15s. Hidden when count is 0.
// Only visible for the roles that can act on approvals.
import { useEffect, useState } from "react";
import api from "../../../services/api";
import useAuthStore from "../../../store/authStore";

const ELIGIBLE = new Set(["admin", "founder", "ceo", "main_hub_manager", "micro_hub_lead"]);

export default function ApprovalsSidebarBadge() {
  const user = useAuthStore((s) => s.user);
  const role = (user?.role || "").toLowerCase();
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!ELIGIBLE.has(role)) return undefined;
    let cancelled = false;
    const tick = async () => {
      try {
        if (role === "admin" || role === "founder" || role === "ceo") {
          const r = await api.get("/approvals/metrics");
          if (!cancelled) setCount(r.data?.pending_count || 0);
        } else {
          // MHM + Lead use their auto-scoped queue size.
          const r = await api.get("/approvals/queue",
                                       { params: { status: "pending", limit: 1 } });
          if (!cancelled) setCount(r.data?.total || 0);
        }
      } catch { /* noop */ }
    };
    tick();
    const id = setInterval(tick, 15_000);
    return () => { cancelled = true; clearInterval(id); };
  }, [role]);

  if (!ELIGIBLE.has(role) || count <= 0) return null;
  return (
    <span data-testid="sidebar-approvals-pending-badge"
          data-count={count}
          className="ml-auto bg-[#FF6B00] text-white text-[10px] font-bold rounded-full px-2 py-0.5">
      {count > 99 ? "99+" : count}
    </span>
  );
}
